<template>
  <div>
    <vx-tooltip
      :delay="tooltipDelay"
      :text="tooltipText"
      :tooltipPosition="tooltipPosition"
    >
      <feather-icon
        icon="UserPlusIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-popup fullscreen :title="$t('link_payrolls')" :active.sync="active">
      <div>
        <h4>{{ $t('information') }}</h4>
        <vs-row class="my-3">
          <vs-col vs-w="3">
            <b>{{ $t('client') }}:</b> {{ data.ClientName }}
          </vs-col>
          <vs-col vs-w="5">
            <b>{{ $t('period') }}:</b> {{ data.WeekInvoice }}
          </vs-col>
          <vs-col vs-offset="2" vs-w="2">
              <vs-button
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-link"
                class="w-full"
                @click="openConfirm"
                v-show="selected.length > 0"
              >
                {{ $t('link_payrolls') }}
              </vs-button>
          </vs-col>
        </vs-row>
        <vs-table :data="payrolls">
          <template slot="thead">
            <th class="qb-sticky" :style="{ textAlign:'center'}"></th>
            <th class="qb-sticky" :style="{ textAlign:'center'}"># {{$t('week')}}</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">{{$t('date')}}</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">{{$t('status')}}</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">RegHours</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">Over Time</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">HCount</th>
            <th class="qb-sticky" :style="{ textAlign:'center'}">Fondos</th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td :style="{ width: '2vw' }">
                <vs-checkbox
                  :vs-value="data[i].id"
                  v-model="selected"
                  :disabled="selected.length>0 && thisRow(data[i].id)"
                ></vs-checkbox>
              </vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.payroll_no}}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ formatDate(tr.date) }}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.status_id }}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.regular_hours }}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.overtime }}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.headcount }}</vs-td>
              <vs-td :style="{ width: '10vw' }">{{ tr.Fondos }}</vs-td>
            </vs-tr>
            <vs-tr v-show="payrolls.length == 0">
              <vs-td :colspan="8" class="text-center">
                <p>{{ tableMessage }}</p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
       <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
        <p>{{$t('are_you_sure')}} {{$t('once_approved_you_can_not_undo_this_action')}}</p>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
             ref="loadableButton" 
             id="link-button-loading" 
             class="w-full vs-con-loading__container" 
              color="primary"
              type="filled"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="linkPayrolls"
              >{{submitButtonText}}</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="confirmActive = false"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
import invoice from '@/http/requests/invoice'
import loading from '@/mixins/Loading.js'

export default {
  mixins: [ loading],
  props: {
    btnColor: {
      type: String,
      default: 'primary'
    },
    btnType: {
      type: String,
      default: 'border'
    },
    btnIcon: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'button'
    },
    popupTitle: {
      type: String,
      default: 'title'
    },
    tooltipDelay: {
      type: String,
      default: '1.5s'
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    tooltipText: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: false,
      confirmActive: false,
      lastPage: 1,
      params: {
        page: 1
      },
      payrolls: [],
      selected: [],
      tableMessage:'', 
      submitButtonText:this.$i18n.messages[this.$i18n.locale].submit
    }
  },
  methods: {
    thisRow(id){
      if(this.selected[0]==id){
        return false
      }
      return true
    },
    open() {
      this.active = true
      this.selected = []
      this.payrolls = []
      this.search()
    },
    search() {
      this.tableMessage= this.$i18n.messages[this.$i18n.locale].loading+'...'
      this.params.where = ['payrolls.client_id=' + this.data.ClientId]
      invoice.payrollListToLink(this.params).then(res => {
        this.payrolls = res.data.data
        if (res.data.data.length == 0) {
          this.tableMessage = this.$i18n.messages[this.$i18n.locale].no_results
        }
      })
    },
     openConfirm() {
       this.confirmActive=true
    },
    linkPayrolls() {
      this.submitButtonText=this.$i18n.messages[this.$i18n.locale].loading+'...'
      this.openLoading('link-button-loading')
      let params = { 
        payrollIds: this.selected,
        invoiceId : this.data.InvoiceId
        }
      invoice.linkPayrollsToInvoice(params).then(res => {
      //this.$store.dispatch('invoice/linkPayrollsToInvoice',params).then( res => {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: this.$i18n.messages[this.$i18n.locale].invoice_linked
        })
        this.$emit('linked',params);
        this.closeLoading('link-button-loading')
        this.confirmActive=false
        this.active = false
        this.submitButtonText=this.$i18n.messages[this.$i18n.locale].submit
      }).catch(err => {
        console.log(err)
        this.$vs.notify({
          color: 'danger',
          title: 'Oops...',
          text: 'Something went wrong'
        })
        this.submitButtonText=this.$i18n.messages[this.$i18n.locale].submit
        this.closeLoading('link-button-loading')
      })

    }
  },

}
</script>


<style>
.text-center {
  text-align: center;
}
</style>